<template>
  <th class="text-center">
    <v-dialog v-model="dialog" max-width="400px" content-class="rounded-xl">
      <template v-slot:activator="{ on }">
        <v-btn fab x-small text v-on="on">
          <v-icon small>mdi-wrench</v-icon>
        </v-btn>
      </template>
      <v-card class="roundex-xl">
        <v-card-title>
          <span class="headline"> Фильтр времени суток </span>
          <v-spacer></v-spacer>

          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-tabs fixed-tabs icons-and-text>
          <v-tab dense>
            Точное значение
            <v-icon left>mdi-bullseye-arrow</v-icon>
          </v-tab>
          <v-tab dense>
            Интервалы
            <v-icon left> mdi-format-list-bulleted</v-icon>
          </v-tab>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-select
                        :items="hours"
                        item-value="hour"
                        item-text="hour"
                        clearable
                        label="Час"
                        :menu-props="{
                          bottom: true,
                          offsetY: true,
                          minWidth: 150,
                          transition: 'scale-transition',
                        }"
                        @change="changed"
                        v-model="selectedHour"
                      >
                      </v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        ref="select"
                        :items="minutes"
                        clearable
                        item-value="minutes"
                        item-text="minutes"
                        label="Минута"
                        :menu-props="{
                          bottom: true,
                          offsetY: true,
                          minWidth: 150,
                          transition: 'scale-transition',
                        }"
                        @change="changed"
                        v-model="selectedMinute"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-select
                      clearable
                      :items="intervals"
                      :menu-props="{
                        bottom: true,
                        offsetY: true,
                      }"
                      @change="changedInterval"
                      v-model="selectedInterval"
                    >
                      Интервалы
                    </v-select>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
  </th>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      selectedHour: "",
      selectedMinute: "",
      selectedInterval: "",
      hours: [
        { id: -1, hour: "" },
        { id: 0, hour: "00" },
        { id: 1, hour: "01" },
        { id: 2, hour: "02" },
        { id: 3, hour: "03" },
        { id: 4, hour: "04" },
        { id: 5, hour: "05" },
        { id: 6, hour: "06" },
        { id: 7, hour: "07" },
        { id: 8, hour: "08" },
        { id: 9, hour: "09" },
        { id: 10, hour: "10" },
        { id: 11, hour: "11" },
        { id: 12, hour: "12" },
        { id: 13, hour: "13" },
        { id: 14, hour: "14" },
        { id: 15, hour: "15" },
        { id: 16, hour: "16" },
        { id: 17, hour: "17" },
        { id: 18, hour: "18" },
        { id: 19, hour: "19" },
        { id: 20, hour: "20" },
        { id: 21, hour: "21" },
        { id: 22, hour: "22" },
        { id: 23, hour: "23" },
      ],
      minutes: [
        { id: -1, minutes: "" },
        { id: 0, minutes: "00" },
        { id: 1, minutes: "05" },
        { id: 2, minutes: "10" },
        { id: 3, minutes: "15" },
        { id: 4, minutes: "20" },
        { id: 5, minutes: "25" },
        { id: 6, minutes: "30" },
        { id: 7, minutes: "35" },
        { id: 8, minutes: "40" },
        { id: 9, minutes: "45" },
        { id: 10, minutes: "50" },
        { id: 11, minutes: "55" },
      ],
      intervals: ["00/20/40", "05/25/45", "10/30/50", "15/35/55"],
    };
  },
  methods: {
    ...mapActions(["setFilterKey", "deleteFilterKey"]),
    ...mapGetters(["getSettings"]),
    changed: function () {
      let key = "timestamp__time_of_day__regex";
      this.selectedInterval = "";
      if (this.selectedHour == "" && this.selectedMinute == "") {
        this.deleteFilterKey({ key_to_delete: key });
        this.$emit("filter_update");
        return;
      }
      console.log("Hour:" + this.selectedHour, "Minute:" + this.selectedMinute);
      var hour = this.selectedHour ? this.selectedHour : ".*";
      var minute = this.selectedMinute ? this.selectedMinute : ".*";
      let value = "^" + hour + ":" + minute + ":00$";
      console.log("Selected: " + value);

      this.setFilterKey({ key, value });
      this.$emit("filter_update");
    },
    changedInterval: function () {
      console.log("changed");
      let key = "timestamp__time_of_day__regex";
      this.selectedHour = "";
      this.selectedMinute = "";
      console.log(this.selectedInterval);
      if (!this.selectedInterval) {
        this.deleteFilterKey({ key_to_delete: key });
        this.$emit("filter_update");
        return;
      }

      var interval = this.selectedInterval.replaceAll("/", "|");
      let value = "^" + String.raw`\d\d` + ":(" + interval + "):00$";
      console.log("Value:" + value);
      this.setFilterKey({ key, value });
      this.$emit("filter_update");
    },

    findValueByPrefix: function (object, prefix) {
      for (var property in object) {
        if (
          Object.prototype.hasOwnProperty.call(object, property) &&
          property.toString().startsWith(prefix)
        ) {
          return [property, object[property]];
        }
      }
    },
  },

  mounted() {},
  created() {
    let settings = this.getSettings().filters;

    let result = this.findValueByPrefix(
      settings,
      "timestamp__time_of_day__regex"
    );
    if (!result) {
      return;
      // TODO: intervals
    }
    if (result[1].includes("|")) {
      this.selectedInterval = result[1]
        .split(":")[1]
        .replaceAll("|", "/")
        .slice(1)
        .slice(0, -1);
      return;
    }
    let hour = result[1].split(":")[0].slice(1);
    let minute = result[1].split(":")[1];
    this.selectedHour = hour;
    this.selectedMinute = minute;
  },
};
</script>

<style>
.select.v-text-field.v-text-field--enclosed:not(.v-text-field--dense)
  > .v-input__control
  > .v-input__slot {
  overflow: hidden !important;
  padding-right: 4px !important;
  padding-left: 4px !important;
}
.v-input__icon {
  padding-top: 3px !important;
  min-width: 15px !important;
  width: 12px !important;
}
</style>
